import appAxios from '@/axios/appAxios';
export default{
namespaced:true,
state:{
    list:[]
},
getters:{
    getList(state){
        return state.list
    },
},
mutations:{
    setList(state,list){
        state.list=list
    }
},
actions:{
   async fetchList(context){
    await appAxios.get('/AppRole').then(({data})=>{
       context.commit('setList',data)
    }).catch((err)=>{
        console.log(err);
    })
   }
}

}